Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isTouchDevice;
function isTouchDevice() {
  return !!(typeof window !== 'undefined' && 'ontouchstart' in window) || !!(typeof navigator !== 'undefined' && navigator.maxTouchPoints);
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dates/lib/utils/isTouchDevice.js
 ** module id = 707
 ** module chunks = 0
 **/